import React from "react";
import ProjectsSection from "../components/projects/ProjectSecton";

function Projects() {
  return (
    <div>
      <ProjectsSection />
    </div>
  );
}

export default Projects;
